// material-ui
import { alpha, createTheme } from "@mui/material/styles";

// third-party
import {
  PalettesProps,
  presetDarkPalettes,
  presetPalettes,
} from "@ant-design/colors";

// project imports
import { ThemeMode } from "config";
import ThemeOption from "./theme";
import {
  MANTIS_BG_PAPER,
  MANTIS_DIVIDER,
  MANTIS_TEXT_PRIMARY,
  MANTIS_TEXT_SECONDARY,
} from "./tokens";

// Mantis "Container" token — Toby brand surface gray, applied as the dashboard
// body background in light mode.
const SURFACE_GRAY = "#EDF3FC";

// types
import { PresetColor } from "types/config";
import { PaletteThemeProps } from "types/theme";

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode: ThemeMode, presetColor: PresetColor) {
  const colors: PalettesProps =
    mode === ThemeMode.DARK ? presetDarkPalettes : presetPalettes;

  let greyPrimary = [
    "#fcfdff", // 0
    "#e4e6ef", // 50
    "#d3d5e0", // 100
    "#9297a7", // 200
    "#63697e", // 300
    "#3d445c", // 400
    "#2c344d", // 500
    "#202842", // 600
    "#161f3a", // 700
    "#0f1734", // 800
    "#050e2b", // 900
  ];
  let greyAscent = ["#fafafa", "#bfbfbf", "#434343", "#1f1f1f"];
  let greyConstant = ["#fafafb", "#e6ebf1"];

  if (mode === ThemeMode.DARK) {
    greyPrimary = [
      "#000000",
      "#141414",
      "#1e1e1e",
      "#595959",
      "#8c8c8c",
      "#bfbfbf",
      "#d9d9d9",
      "#f0f0f0",
      "#f5f5f5",
      "#fafafa",
      "#ffffff",
    ];
    // greyPrimary.reverse();
    greyAscent = ["#fafafa", "#bfbfbf", "#434343", "#1f1f1f"];
    greyConstant = ["#121212", "#d3d8db"];
  }
  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor: PaletteThemeProps = ThemeOption(colors, presetColor);

  return createTheme({
    palette: {
      mode,
      common: {
        black: "#000",
        white: "#fff",
      },
      ...paletteColor,
      text: {
        primary:
          mode === ThemeMode.DARK
            ? alpha(paletteColor.grey[900]!, 0.87)
            : MANTIS_TEXT_PRIMARY,
        secondary:
          mode === ThemeMode.DARK
            ? alpha(paletteColor.grey[900]!, 0.45)
            : MANTIS_TEXT_SECONDARY,
        disabled:
          mode === ThemeMode.DARK
            ? alpha(paletteColor.grey[900]!, 0.1)
            : paletteColor.grey[400],
      },
      action: {
        disabled: paletteColor.grey[300],
      },
      divider:
        mode === ThemeMode.DARK
          ? alpha(paletteColor.grey[900]!, 0.05)
          : MANTIS_DIVIDER,
      background: {
        paper:
          mode === ThemeMode.DARK ? paletteColor.grey[100] : MANTIS_BG_PAPER,
        default: mode === ThemeMode.DARK ? paletteColor.grey.A50 : SURFACE_GRAY,
      },
    },
  });
}
